const content = require('../html/brand.html')
const {addRoutePostRender, registerRoute} = require('./router')
const {createElementFromHTML} = require('./utils')

function brandPage() {
	return createElementFromHTML(content)
}

registerRoute('brand', '/brand', brandPage)